import "jquery";

import {HttpClient} from "./lib/http.service";

export class CookieConsent {

    private client :HttpClient;

    // KP TODO get rid of jquery.

    // private cookieConsentBar :HTMLDivElement;
    private cookieConsentBar;
    private cookieConsentBtn :HTMLButtonElement;
    // private cookieConsentBtn;

    constructor(){
        // this.cookieConsentBar = <HTMLDivElement>document.getElementById('cookie-consent-bar');
        this.cookieConsentBar = jQuery('#cookie-consent-bar');
        this.cookieConsentBtn = <HTMLButtonElement>document.getElementById('cookie-consent-btn');
        // this.cookieConsentBtn = jQuery('#cookie-consent-btn');

        // jQuery(document).ready(() => this.checkForCookieConset());
        if(this.cookieConsentBtn){
            this.client = new HttpClient();
            this.cookieConsentBtn.addEventListener("click",() => this.setCookie(this.client));
        }
    }

    setCookie(client :HttpClient){
        console.log("setCookie");
        client.post('/interaction/cookie/consent')
            .subscribe(
            c => {
                console.log(c);
                this.cookieConsentBar.hide();
            }
        );
    }

    // checkForCookieConset() {
    //     if(!this.getCookie("CCAG")){
    //         this.cookieConsentBar.show();
    //     }
    // }
    //
    // getCookie(c_name) {
    //     if (document.cookie.length > 0) {
    //         var c_start = document.cookie.indexOf(c_name + "=");
    //         if (c_start != -1) {
    //             c_start = c_start + c_name.length + 1;
    //             var c_end = document.cookie.indexOf(";", c_start);
    //             if (c_end == -1) {
    //                 c_end = document.cookie.length;
    //             }
    //             return unescape(document.cookie.substring(c_start, c_end));
    //         }
    //     }
    //     return "";
    // }

}

